import $ from "jquery";
import config from '../../config.json';
import auth from '../../auth/auth.react.js';
import React from 'react';
import {
  Card,
  CardHeader,
  CardText
} from 'material-ui/Card';
import {
  Redirect
} from 'react-router-dom'
import {
  FormControlLabel
} from 'material-ui-next/Form';
import Checkbox from 'material-ui-next/Checkbox';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Joi from 'joi';
import validation from 'react-validation-mixin';
import strategy from 'joi-validation-strategy';
import CSSModules from 'react-css-modules';
import styles from './all.css';
import AdminIcon from '../../assets/icons/adminIcon.react.js';
import ShieldOutlineIcon from '../../assets/icons/shieldOutlineIcon.react.js';

const create_url = config.server + config.api_path + '/admin/user/create'

class AdminCreateUser extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      msg: null,
      redirect: null,
      username: '',
      password: '',
      admin: null,
    }

    this.validatorTypes = {
      username: Joi.string()
        .required()
        .email()
        .label('Username'),
      password: Joi.string()
        .required()
        .min(1)
        .max(80)
        .label('Password'),
      admin: Joi.string()
        .optional()
        .allow([null, '1'])
        .label('Admin Option')
    }

    this.handleSwitch = this.handleSwitch.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  handleChange(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleBlur(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
        [name]: value
      },
      this.props.handleValidation(name)
    )
  }

  handleSwitch(name) {
    return (e) => {
      this.setState({
        [name]: e.target.checked
      });
    }
  }

  onSubmit(e) {
    e.preventDefault()
    this.props.validate((err) => {
      if (err) return
      const admin_option = this.state.admin ? '1' : null;
      var account_data = {
        username: this.state.username,
        password: this.state.password
      }
      if (admin_option) {
        account_data.admin = admin_option
      }
      $.post({
          dataType: 'json',
          url: create_url,
          contentType: 'application/json',
          data: auth.with_session(account_data),
          xhrFields: {
            withCredentials: true
          }
        })
        .done((data) => {
          var _err = data.err
          if (_err && _err.ec === 0) {
            this.setState({
              redirect: '/admin/user/all'
            })
          } else if (_err && _err.ec === 403) {
            this.props.unauthorized()
          } else if (_err) {
            this.setState({
              msg: _err.em
            })
          }
        })
    })
  }

  getValidatorData() {
    return this.state
  }

  renderHelperText(msg) {
    var err_msg = msg
    if (Array.isArray(msg) && msg.length > 0) {
      err_msg = msg[0]
    }
    return (
      <span styleName="">{err_msg}</span>
    )
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={{pathname: this.state.redirect}} />
    }
    const adminCheckbox = (
      <Checkbox
        checkedIcon={<AdminIcon />}
        icon={<ShieldOutlineIcon />}
        checked={this.state.admin}
        onChange={this.handleSwitch('admin')}
      />
    )
    return (
      <Card styleName="admin-card">
        <CardHeader
          title="Create New User"
          subtitle={this.state.msg}
          actAsExpander={false}
          showExpandableButton={false}
        />
        <CardText>
          <TextField
            floatingLabelText="Username - email"
            floatingLabelFixed={true}
            name="username"
            value={this.state.username}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            errorText={this.renderHelperText(this.props.getValidationMessages('username'))} />
          <br />
          <TextField
            floatingLabelText="Password"
            floatingLabelFixed={true}
            name="password"
            value={this.state.password}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            errorText={this.renderHelperText(this.props.getValidationMessages('password'))} />
          <br />
          <FormControlLabel control={adminCheckbox} label="Admin User" />
          <br />

          <RaisedButton backgroundColor="#3ed5ad" labelColor="#ffffff" label={"Create User " + this.state.username} styleName="admin-button" onClick={this.onSubmit} disabled={!this.props.isValid()} />
        </CardText>
      </Card>
    )
  }
}

export default validation(strategy)(CSSModules(AdminCreateUser, styles))



// WEBPACK FOOTER //
// ./src/views/admin/new_user.react.js